export class CurrentWsState {
    hasCurrentWs: boolean = false;
    name: string = '';
    memberCount: number = 0;
    observerCount: number = 0;
    isInitialized: boolean = false;
}